var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "schedule-calendar-skeleton d-flex flex-column ga-4",
      style: { minHeight: `${_setup.SCHEDULE_CALENDAR_MIN_HEIGHT_PX}px` },
    },
    [
      _c(
        "div",
        {
          staticClass: "schedule-calendar-skeleton__days d-flex align-end ga-2",
        },
        _vm._l(6, function (index) {
          return _c("div", {
            key: `day-skeleton-${index}`,
            staticClass: "schedule-calendar-skeleton__day flex-shrink-0",
          })
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "schedule-calendar-skeleton__slots",
          class: _setup.isMobile
            ? "schedule-calendar-skeleton__slots--mobile"
            : "schedule-calendar-skeleton__slots--desktop",
        },
        _vm._l(8, function (index) {
          return _c("div", {
            key: `slot-skeleton-${index}`,
            staticClass: "schedule-calendar-skeleton__slot",
          })
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }